module.exports = __webpack_public_path__ + "img/triangle.a20e2d82.svg";